import * as actions from './actions'
import {Map, fromJS} from 'immutable';

function reducer(state=Map({}),action) {
    switch (action.type) {
        case actions.PAYMENT_INFO_SUCCEEDED:
            return state.set('plans', fromJS(action.payload))
        case actions.PAYMENT_INFO_REQUESTED:
            return state
        case actions.PAYMENT_INFO_FAILED:
        default:
            return state
      }
}


export default reducer



// WEBPACK FOOTER //
// ./src/model/Payment/reducer.js